/**
 *
 * OrderOverview
 *
 */
import { ReactComponent as EmptyIcon } from 'app/assets/img/empty.svg';
import StyledButton from 'app/components/StyledButton';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { formatNumber, formatTimeFrame } from 'utils/helper';
// import { CheckoutOrderOverviewWrapper } from './styled';
import moment from 'moment';
import styled from 'styled-components';
import useWindowSize, { TABLET_WIDTH } from 'app/hooks/useWindowSize';
import { InputNumberContainer } from 'app/components/InputNumberContainer/Loadable';
import { TGroupedItem } from './types';
import { Carousel, Divider } from 'antd';
import { isNil } from 'lodash';
interface Props {
  listCart: TGroupedItem[];
  isValid: boolean;
  isSubmitting?: boolean;
}

export const CheckoutOrderOverview = memo(
  ({ listCart, isSubmitting = false }: Props) => {
    const translations = useSelector(selectTranslations);
    const { device } = useWindowSize();
    const history = useHistory();

    const dataCheckout = useMemo(() => {
      const result: any = [];

      const parkMap = {};

      listCart?.forEach(item => {
        const parkId = item?.park?.id;
        const catalogId = item?.catalog?.id;

        if (!parkMap[parkId]) {
          parkMap[parkId] = {
            park: { ...item.park },
            catalogs: {},
          };
        }

        if (!parkMap[parkId].catalogs[catalogId]) {
          parkMap[parkId].catalogs[catalogId] = {
            catalog: { ...item.catalog },
            items: [],
          };
        }

        parkMap[parkId].catalogs[catalogId].items.push({
          ...item,
          restaurant: item?.restaurant
            ? item?.restaurant
            : item?.restaurants?.[0],
          zone: item?.zone ? item?.zone : item?.zones?.[0],
        });
      });

      for (const parkId in parkMap) {
        const parkEntry = parkMap[parkId];
        result.push({
          park: parkEntry.park,
          catalogs: parkEntry.catalogs,
        });
      }

      return result;
    }, [listCart]);

    return (
      <CheckoutOrderOverviewWrapper>
        <div className="cartSummary">
          <div className="container-itemCard-card">
            {device === 'desktop' ? (
              <>
                {dataCheckout?.length > 0 ? (
                  <>
                    <div className="container-list-itemCard-card">
                      {dataCheckout.map((itemCard: any) => {
                        return (
                          <>
                            <div className="itemCard-card">
                              <div className="--title-card">
                                {itemCard?.park?.name}
                              </div>
                              <div className="--content">
                                {Object.values(itemCard.catalogs).map(
                                  (val: any, idx) => (
                                    <>
                                      <div
                                        className="--title-content mb-4"
                                        style={{ fontSize: '16px' }}
                                      >
                                        {val?.catalog?.name}
                                      </div>
                                      {val.items
                                        .sort(
                                          (a, b) =>
                                            -(a.isGift ? 1 : 0) +
                                            (b.isGift ? 1 : 0),
                                        )
                                        .map((item, idx) => {
                                          return (
                                            <>
                                              <div className="--description mb-4">
                                                {item?.name ?? item?.show?.name}
                                              </div>
                                              <div className="d-flex justify-content-between mb-4">
                                                <div className="--row-key">
                                                  {translations
                                                    ? translations[
                                                        'b2c.txt.date-use-1'
                                                      ]
                                                    : ''}
                                                </div>
                                                <div className="--row-value">
                                                  {/* Vé combo hoặc vé FOC */}
                                                  {translations
                                                    ? translations[
                                                        'b2c.txt.use-from'
                                                      ]
                                                    : ''}{' '}
                                                  {moment(
                                                    item?.date ?? '',
                                                  ).format('YYYY-MM-DD')}
                                                </div>
                                              </div>
                                              {!isNil(
                                                item?.product
                                                  ?.usedArea2Object ||
                                                  item?.usedArea2 ||
                                                  item?.used_area2,
                                              ) && (
                                                <div className="d-flex justify-content-between mb-4">
                                                  <div className="--row-key">
                                                    {item?.show
                                                      ?.usedArea2Label ||
                                                      translations?.[
                                                        'b2c.txt.hours'
                                                      ] ||
                                                      ''}
                                                  </div>
                                                  <div className="--row-value">
                                                    {formatTimeFrame(
                                                      item?.product
                                                        ?.usedArea2Object
                                                        ?.label ||
                                                        item?.usedArea2 ||
                                                        item?.used_area2,
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                              {item?.zone?.name && (
                                                <div className="d-flex justify-content-between mb-4">
                                                  <div className="--row-key">
                                                    {item?.show
                                                      ?.usedArea1Label ||
                                                      translations?.[
                                                        'b2c.txt.zone'
                                                      ] ||
                                                      ''}
                                                  </div>
                                                  <div className="--row-value">
                                                    {item?.zone?.name}
                                                  </div>
                                                </div>
                                              )}
                                              {item?.restaurant?.name && (
                                                <div className="d-flex justify-content-between mb-4">
                                                  <div className="--row-key">
                                                    {item?.show
                                                      ?.usedArea1Label ||
                                                      translations?.[
                                                        'b2c.text.restaurants'
                                                      ] ||
                                                      ''}
                                                  </div>
                                                  <div className="--row-value">
                                                    {item?.restaurant?.name}
                                                  </div>
                                                </div>
                                              )}
                                              <div className="d-flex justify-content-between mb-4">
                                                <div className="--row-key">
                                                  {translations
                                                    ? translations[
                                                        'b2c.txt.price-ticket'
                                                      ]
                                                    : ''}
                                                </div>
                                                <div className="--price-card --row-value">
                                                  {`${formatNumber(
                                                    +item.price,
                                                  )}đ`}
                                                </div>
                                              </div>
                                              <div className="d-flex justify-content-between mb-4 align-items-center">
                                                <div className="--row-key">
                                                  {translations
                                                    ? translations[
                                                        'b2c.txt.total-amount'
                                                      ]
                                                    : ''}
                                                </div>
                                                <div className="form-inputNumber">
                                                  <InputNumberContainer
                                                    disabled
                                                    value={+item?.amount || 0}
                                                    onChange={() => {}}
                                                  />
                                                </div>
                                                <div className="--price-card --row-value">
                                                  {' '}
                                                  {`${formatNumber(
                                                    +item.price * +item?.amount,
                                                  )}đ`}
                                                </div>
                                              </div>
                                              {idx < val.items.length - 1 && (
                                                <Divider dashed />
                                              )}
                                            </>
                                          );
                                        })}
                                      {idx <
                                        Object.values(itemCard.catalogs)
                                          .length -
                                          1 && <Divider dashed />}
                                    </>
                                  ),
                                )}
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                    <div className="box-total">
                      <div className="d-flex justify-content-between mt-4 mb-2">
                        <div
                          className="--title-total"
                          style={{ fontSize: '16px' }}
                        >
                          {translations
                            ? translations['b2c.txt.total-amount']
                            : ''}
                        </div>
                        <div
                          className="total-after-discount"
                          style={{ fontSize: '16px' }}
                        >
                          {formatNumber(
                            listCart.reduce((sum, item) => {
                              return sum + item.price * item.amount;
                            }, 0),
                          )}
                          đ
                        </div>
                      </div>
                      <div className="d-flex mt-3 justify-content-between">
                        <div
                          className="d-flex justify-content-between align-items-center mr-2"
                          style={{
                            flex: 1,
                            marginRight: 7,
                            display: 'flex',
                          }}
                        >
                          <StyledButton
                            textColor="#808080"
                            bgColor="white"
                            style={{ flex: 1, width: 'auto' }}
                            border="1px solid #808080"
                            onClick={() => {
                              history.goBack();
                            }}
                          >
                            <i className="fa-solid fa-arrow-left"></i>
                            <span
                              className="--textBtn"
                              style={{
                                marginLeft: 8,
                              }}
                            >
                              {translations ? translations['b2c.txt.back'] : ''}
                            </span>
                          </StyledButton>
                        </div>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ flex: 1, marginLeft: 7 }}
                        >
                          <StyledButton
                            htmlType="submit"
                            disabled={isSubmitting}
                            style={{ flex: 1, width: 'auto' }}
                            textColor="white"
                            onClick={() => {}}
                          >
                            <span
                              className="--textBtnNext"
                              style={{
                                marginRight: 8,
                              }}
                            >
                              {translations
                                ? translations['b2c.txt.continue']
                                : ''}
                            </span>
                            <i className="fa-solid fa-arrow-right"></i>
                          </StyledButton>
                        </div>
                      </div>
                      <div className="group-policy">
                        <div
                          className="--text-policy"
                          style={{ textTransform: 'capitalize' }}
                        >
                          {translations
                            ? translations['b2c.txt.policy-title']
                            : ''}
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <div className="--dot"></div>
                          <div>
                            {translations
                              ? translations['b2c.txt.policy-1-description']
                              : ''}
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <div className="--dot"></div>
                          <div>
                            {translations
                              ? translations['b2c.txt.policy-2-description']
                              : ''}
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <div className="--dot"></div>
                          <div>
                            {translations
                              ? translations['b2c.txt.policy-3-description']
                              : ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="--empty d-flex align-items-center justify-content-center mb-3">
                    <EmptyIcon />
                  </div>
                )}
              </>
            ) : (
              <>
                {listCart?.length > 0 ? (
                  <>
                    <div
                      className="container-list-item-card"
                      style={{ overflow: 'initial' }}
                    >
                      <ListTicketCarousel
                        infinite={false}
                        dots={{ className: 'ticket-dots' }}
                      >
                        {listCart
                          .sort(
                            (a: any, b: any) =>
                              -(a.isGift ? 1 : 0) + (b.isGift ? 1 : 0),
                          )
                          .map((itemCard: any, index) => {
                            return (
                              <>
                                <div
                                  className="itemCard-card"
                                  key={index}
                                  style={{
                                    marginBottom: 0,
                                    marginLeft: 8,
                                    marginRight: 8,
                                  }}
                                >
                                  <div className="--title-card">
                                    {itemCard?.park?.name}
                                  </div>
                                  <div className="--content">
                                    <div className="--title-content mb-4">
                                      {itemCard?.catalog?.name}
                                    </div>
                                    <>
                                      <div className="--description mb-4">
                                        {itemCard?.show?.name ?? itemCard.name}
                                      </div>
                                      <div className="d-flex justify-content-between mb-4">
                                        <div className="--row-key">
                                          {translations
                                            ? translations['b2c.txt.date-use-1']
                                            : ''}
                                        </div>
                                        <div className="--row-value">
                                          {translations
                                            ? translations['b2c.txt.use-from']
                                            : ''}{' '}
                                          {itemCard?.date ?? ''}
                                        </div>
                                      </div>
                                      {!isNil(
                                        itemCard?.product?.usedArea2Object,
                                      ) && (
                                        <div className="d-flex justify-content-between mb-4">
                                          <div className="--row-key">
                                            {itemCard?.show?.usedArea2Label ||
                                              translations?.['b2c.txt.hours'] ||
                                              ''}
                                          </div>
                                          <div className="--row-value">
                                            {
                                              itemCard?.product?.usedArea2Object
                                                ?.label
                                            }
                                          </div>
                                        </div>
                                      )}
                                      {itemCard?.zone?.name && (
                                        <div className="d-flex justify-content-between mb-4">
                                          <div className="--row-key">
                                            {itemCard?.show?.usedArea1Label ||
                                              translations?.['b2c.txt.zone'] ||
                                              ''}
                                          </div>
                                          <div className="--row-value">
                                            {itemCard?.zone?.name}
                                          </div>
                                        </div>
                                      )}
                                      {itemCard?.restaurant?.name && (
                                        <div className="d-flex justify-content-between mb-4">
                                          <div className="--row-key">
                                            {itemCard?.show?.usedArea1Label ||
                                              translations?.[
                                                'b2c.text.restaurants'
                                              ] ||
                                              ''}
                                          </div>
                                          <div className="--row-value">
                                            {itemCard?.restaurant?.name}
                                          </div>
                                        </div>
                                      )}
                                      <div className="d-flex justify-content-between mb-4">
                                        <div className="--row-key">
                                          {translations
                                            ? translations[
                                                'b2c.txt.price-ticket'
                                              ]
                                            : ''}
                                        </div>
                                        <div
                                          className="--price-card --row-value"
                                          style={{ color: '#e92127' }}
                                        >{`${formatNumber(
                                          +itemCard?.price,
                                        )}đ`}</div>
                                      </div>
                                      <div className="d-flex justify-content-between mb-4 align-items-center">
                                        <div className="--row-key">
                                          {translations
                                            ? translations[
                                                'b2c.txt.total-amount'
                                              ]
                                            : ''}
                                        </div>
                                        <div className="form-inputNumber">
                                          <InputNumberContainer
                                            disabled
                                            value={+itemCard?.amount || 0}
                                            onChange={() => {}}
                                          />
                                        </div>
                                        <div
                                          className="--price-card --row-value"
                                          style={{ color: '#e92127' }}
                                        >
                                          {' '}
                                          {`${formatNumber(
                                            +itemCard?.price *
                                              +itemCard?.amount,
                                          )}đ`}
                                        </div>
                                      </div>
                                    </>
                                  </div>
                                </div>
                              </>
                            );
                          })}
                      </ListTicketCarousel>
                    </div>
                    <div className="box-total" style={{ padding: '8px' }}>
                      <div className="d-flex justify-content-between mt-4 mb-2">
                        <div className="--title-total">
                          {translations
                            ? translations['b2c.txt.total-amount']
                            : ''}
                        </div>
                        <div className="total-after-discount">
                          {formatNumber(
                            listCart.reduce((sum, item) => {
                              return sum + item.price * item.amount;
                            }, 0),
                          )}
                          đ
                        </div>
                      </div>
                      <div
                        className={`${
                          device !== 'mobile' && 'd-flex'
                        } mt-3 justify-content-between`}
                      >
                        <div
                          className="d-flex justify-content-between align-items-center mr-2"
                          style={{
                            flex: 1,
                            marginRight: device !== 'mobile' ? 7 : 0,
                          }}
                        >
                          <StyledButton
                            textColor="#808080"
                            bgColor="white"
                            style={{ flex: 1 }}
                            border="1px solid #808080"
                            onClick={() => {}}
                          >
                            <i className="fa-solid fa-arrow-left"></i>
                            <span
                              className="--textBtn"
                              style={{
                                marginLeft: 8,
                              }}
                            >
                              {translations ? translations['b2c.txt.back'] : ''}
                            </span>
                          </StyledButton>
                        </div>
                        <div
                          className={`d-flex justify-content-between align-items-center ${
                            device === 'mobile' && 'mt-2'
                          }`}
                          style={{
                            flex: 1,
                            marginLeft: device !== 'mobile' ? 7 : 0,
                          }}
                        >
                          <StyledButton
                            style={{ flex: 1 }}
                            textColor="white"
                            onClick={() => {}}
                            htmlType="submit"
                            disabled={isSubmitting}
                          >
                            <span
                              className="--textBtnNext"
                              style={{
                                marginRight: 8,
                              }}
                            >
                              {translations
                                ? translations['b2c.txt.continue']
                                : ''}
                            </span>
                            <i className="fa-solid fa-arrow-right"></i>
                          </StyledButton>
                          {/* <button
                        // disabled={loadingCheckout || !cartLocal.size}
                        className="btn  btn-goCheckout"
                        onClick={onCheckout}
                      >
                        
                      </button> */}
                        </div>
                      </div>
                      <div className="group-policy">
                        <div
                          className="--text-policy"
                          style={{ textTransform: 'capitalize' }}
                        >
                          {translations
                            ? translations['b2c.txt.policy-title']
                            : ''}
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <div className="--dot"></div>
                          <div>
                            {translations
                              ? translations['b2c.txt.policy-1-description']
                              : ''}
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <div className="--dot"></div>
                          <div>
                            {translations
                              ? translations['b2c.txt.policy-2-description']
                              : ''}
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <div className="--dot"></div>
                          <div>
                            {translations
                              ? translations['b2c.txt.policy-3-description']
                              : ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="--empty d-flex align-items-center justify-content-center mb-3">
                    <EmptyIcon />
                  </div>
                )}
              </>
            )}
          </div>

          {/* <div className="--btnGroup">
            <button
              disabled={loadingCheckout || !cartLocal.size}
              className="btn btnPrimary btn-goCheckout"
              onClick={onCheckout}
            >
              <span>{translations ? translations['b2c.txt.pay'] : ''}</span>
            </button>
          </div> */}
        </div>
      </CheckoutOrderOverviewWrapper>
    );
  },
);

const CheckoutOrderOverviewWrapper = styled.div`
  // position: sticky;
  // top: 100px;
  padding: 32px 20px;
  padding-top: 0px;
  @media (max-width: ${_ => TABLET_WIDTH}px) {
    padding: 16px;
  }
  border-radius: 20px;
  background-color: #fff;
  height: auto;
  box-shadow: 0px 20px 20px 0px #0000000d;
  .--title-total,
  .--title-discount {
    font-size: 14px;
    font-weight: 500;
  }
  .--title-payment {
    font-size: 16px;
    font-weight: 500;
  }
  .--dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 1px solid #000000;
    margin-right: 9px;
  }
  .--time {
    font-size: 14px;
    font-weight: 600;
  }
  .--name {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .container-list-itemCard-card {
    max-height: 677px;
    overflow: auto;
    @media (max-width: ${_ => TABLET_WIDTH}px) {
      max-height: none;
      /* height: unset; */
      overflow: visible;
    }
    ::-webkit-scrollbar {
      width: 6px; /* Width of the scrollbar */
    }

    /* Define the track (the area behind the thumb) */
    ::-webkit-scrollbar-track {
      background: transparent; /* Color of the track */
    }

    /* Define the scrollbar thumb */
    ::-webkit-scrollbar-thumb {
      background: #ececec; /* Color of the thumb */
      border-radius: 20px;
    }

    /* Define the scrollbar thumb on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #d6d6d6; /* Color of the thumb on hover */
    }
  }

  .--title-content,
  .--description {
    font-size: 14px;
    font-weight: 600;
  }

  .card .--price-discount,
  .total-price {
    color: #e92127;
    font-weight: 600;
    font-size: 16px;
  }

  .total-after-discount {
    color: #e92127;
    font-weight: 500;
    font-size: 14px;
  }

  .require {
    color: #e92127;
    margin-right: 4px;
  }

  .text-tax {
    font-style: italic;
    font-size: 14px;
    font-weight: 400;
  }

  .group-policy {
    margin-top: 32px;
    font-size: 14px;
    font-weight: 500;
    .--text-policy {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 24px;
    }
  }

  .discount-price {
    color: #f8b117;
    font-weight: 500;
    font-size: 14px;
  }

  .card {
    height: 68px;
    border-radius: 5px;
    background-color: #fff8f8;
    padding: 10px 10px;
    position: relative;
    border: 1px solid #fdd7d7;
    padding: 14px 24px;
    margin: 14px 0px;
    display: flex;
    justify-content: center;
    .title-voucher {
      font-size: 14px;
      font-weight: 500;
      color: #132639;
      margin-right: 12px;
    }
  }

  .card::after {
    position: absolute;
    content: '';
    height: 16px;
    right: -8px;
    border-radius: 8px;
    z-index: 1;
    top: 26px;
    background-color: #ffffff;
    width: 16px;
    border-left: 1px solid #fdd7d7;
  }

  .card::before {
    position: absolute;
    content: '';
    height: 16px;
    left: -8px;
    border-radius: 8px;
    z-index: 1;
    top: 26px;
    background-color: #ffffff;
    width: 16px;
    border-right: 1px solid #fdd7d7;
  }
  .itemCard-card {
    background-color: #fab317;
    border-radius: 10px;
    padding: 1px;
    margin: 24px 0px;
    .--title-card {
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      margin: 20px 11px;
    }
    .--content {
      padding: 24px 11px;
      background-color: #fff;
      border-radius: 10px;
      margin: 5px;
    }
    .--price-card {
      color: #e92127;
    }
    .--row-key {
      font-size: 14px;
      font-weight: 400;
    }
    .--row-value {
      font-size: 14px;
      font-weight: 500;
      text-align: right;
      padding-left: 20px;
    }
    @media (max-width: ${_ => TABLET_WIDTH}px) {
      margin: 0px 8px;
    }
  }
  .form-inputNumber {
    width: 80px;
    height: 30px;
    display: flex;
    align-items: center;
    margin-top: -6px;
    .ant-input-number-input {
      font-size: 14px;
      background-color: #fff;
    }
    .ant-input-number-group-addon {
      line-height: 22px;
      background: #ffffff;
      i {
        color: #d9d9d9 !important;
      }
    }
    .ant-input-number {
      max-width: 70px;
    }
  }
`;

const ListTicketCarousel = styled(Carousel)`
  .slick-dots {
    width: unset;
    /* button:before {
      content: '';
      width: 25px;
      height: 5px;
      border-radius: 10px;
      background: #fab317;
    } */
    /* .slick-active {
      button:before {
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background-color: #c1c1c1;
      }
    } */
  }
  .ticket-dots {
    margin-left: 0;
    margin-right: 0;
    li {
      background: #c1c1c1;
      width: initial;
      height: 5px;
      width: 5px;
      border-radius: 50%;
      overflow: hidden;
      button {
        opacity: 0 !important;
        height: 5px;
        width: 5px;
        background: #c1c1c1;
        &::before {
          display: none;
        }
      }
      &.slick-active {
        width: 25px;
        background: #fab317;
        border-radius: 99px;
      }
    }
  }
  .slick-dots-bottom {
    bottom: -16px;
  }
`;
